const user = "kaiofelipejs"

export const links = [
  {
    label: "Github",
    url: `https://github.com/${user}`,
  },
  {
    label: "Linkedin",
    url: `https://www.linkedin.com/in/${user}`,
  },
  {
    label: "Twitter",
    url: `https://www.twitter.com/${user}`,
  },
  {
    label: "Instagram",
    url: `https://www.instagram.com/${user}`,
  },
]

export default links
